export const certificates = {
  en: {
    // Section Tabs
    myCertificates: 'My Certificates',
    communityShowcase: 'Community Showcase',
    
    // Certificate Types
    quizCompletion: 'Quiz Completion',
    streakAchievement: 'Streak Achievement',
    referralMilestone: 'Referral Milestone',
    eventParticipation: 'Event Participation',
    leadershipRecognition: 'Leadership Recognition',
    
    // Certificate Details
    issued: 'Issued',
    public: 'Public',
    downloads: 'downloads',
    download: 'Download',
    share: 'Share',
    
    // Empty State
    noCertificatesYet: 'No Certificates Yet',
    noPublicCertificates: 'No Public Certificates',
    earnCertificatesMessage: 'Complete quizzes and achieve milestones to earn certificates!',
    checkBackLater: 'Check back later for inspiring achievements from the community.',
    
    // Achievement Tips
    howToEarnTitle: '💡 How to Earn Certificates:',
    tipCompleteQuizzes: '• Complete Bible quizzes with high scores',
    tipMaintainStreaks: '• Maintain daily quiz streaks',
    tipReferFriends: '• Refer friends to join Kingdom Bible Quiz',
    tipParticipateEvents: '• Participate in live events',
    tipShowLeadership: '• Show leadership in your community',
    
    // Error Messages
    error: 'Error',
    loadCertificatesError: 'Failed to load certificates',
    downloadCertificateError: 'Failed to download certificate',
    shareCertificateError: 'Failed to share certificate',
  },
  
  es: {
    // Section Tabs
    myCertificates: 'Mis Certificados',
    communityShowcase: 'Escaparate de la Comunidad',
    
    // Certificate Types
    quizCompletion: 'Finalización de Quiz',
    streakAchievement: 'Logro de Racha',
    referralMilestone: 'Hito de Referido',
    eventParticipation: 'Participación en Evento',
    leadershipRecognition: 'Reconocimiento de Liderazgo',
    
    // Certificate Details
    issued: 'Emitido',
    public: 'Público',
    downloads: 'descargas',
    download: 'Descargar',
    share: 'Compartir',
    
    // Empty State
    noCertificatesYet: 'Aún No Hay Certificados',
    noPublicCertificates: 'No Hay Certificados Públicos',
    earnCertificatesMessage: '¡Completa cuestionarios y logra hitos para ganar certificados!',
    checkBackLater: 'Vuelve más tarde para ver logros inspiradores de la comunidad.',
    
    // Achievement Tips
    howToEarnTitle: '💡 Cómo Ganar Certificados:',
    tipCompleteQuizzes: '• Completa cuestionarios bíblicos con puntajes altos',
    tipMaintainStreaks: '• Mantén rachas diarias de cuestionarios',
    tipReferFriends: '• Refiere amigos para unirse a Kingdom Bible Quiz',
    tipParticipateEvents: '• Participa en eventos en vivo',
    tipShowLeadership: '• Muestra liderazgo en tu comunidad',
    
    // Error Messages
    error: 'Error',
    loadCertificatesError: 'Error al cargar certificados',
    downloadCertificateError: 'Error al descargar certificado',
    shareCertificateError: 'Error al compartir certificado',
  },
  
  fr: {
    // Section Tabs
    myCertificates: 'Mes Certificats',
    communityShowcase: 'Vitrine de la Communauté',
    
    // Certificate Types
    quizCompletion: 'Finalisation de Quiz',
    streakAchievement: 'Accomplissement de Série',
    referralMilestone: 'Étape de Parrainage',
    eventParticipation: 'Participation à un Événement',
    leadershipRecognition: 'Reconnaissance de Leadership',
    
    // Certificate Details
    issued: 'Émis',
    public: 'Public',
    downloads: 'téléchargements',
    download: 'Télécharger',
    share: 'Partager',
    
    // Empty State
    noCertificatesYet: 'Pas Encore de Certificats',
    noPublicCertificates: 'Pas de Certificats Publics',
    earnCertificatesMessage: 'Complétez des quiz et atteignez des étapes pour gagner des certificats !',
    checkBackLater: 'Revenez plus tard pour des réalisations inspirantes de la communauté.',
    
    // Achievement Tips
    howToEarnTitle: '💡 Comment Gagner des Certificats :',
    tipCompleteQuizzes: '• Complétez des quiz bibliques avec de hauts scores',
    tipMaintainStreaks: '• Maintenez des séries quotidiennes de quiz',
    tipReferFriends: '• Parrainez des amis pour rejoindre Kingdom Bible Quiz',
    tipParticipateEvents: '• Participez à des événements en direct',
    tipShowLeadership: '• Montrez du leadership dans votre communauté',
    
    // Error Messages
    error: 'Erreur',
    loadCertificatesError: 'Échec du chargement des certificats',
    downloadCertificateError: 'Échec du téléchargement du certificat',
    shareCertificateError: 'Échec du partage du certificat',
  },
  
  de: {
    // Section Tabs
    myCertificates: 'Meine Zertifikate',
    communityShowcase: 'Community-Schaufenster',
    
    // Certificate Types
    quizCompletion: 'Quiz-Abschluss',
    streakAchievement: 'Serien-Erfolg',
    referralMilestone: 'Empfehlungs-Meilenstein',
    eventParticipation: 'Event-Teilnahme',
    leadershipRecognition: 'Leadership-Anerkennung',
    
    // Certificate Details
    issued: 'Ausgestellt',
    public: 'Öffentlich',
    downloads: 'Downloads',
    download: 'Herunterladen',
    share: 'Teilen',
    
    // Empty State
    noCertificatesYet: 'Noch Keine Zertifikate',
    noPublicCertificates: 'Keine Öffentlichen Zertifikate',
    earnCertificatesMessage: 'Absolviere Quiz und erreiche Meilensteine, um Zertifikate zu verdienen!',
    checkBackLater: 'Schaue später nach inspirierenden Errungenschaften der Community.',
    
    // Achievement Tips
    howToEarnTitle: '💡 Wie man Zertifikate verdient:',
    tipCompleteQuizzes: '• Absolviere Bibel-Quiz mit hohen Punktzahlen',
    tipMaintainStreaks: '• Halte tägliche Quiz-Serien aufrecht',
    tipReferFriends: '• Empfehle Freunden, Kingdom Bible Quiz beizutreten',
    tipParticipateEvents: '• Nimm an Live-Events teil',
    tipShowLeadership: '• Zeige Leadership in deiner Community',
    
    // Error Messages
    error: 'Fehler',
    loadCertificatesError: 'Zertifikate konnten nicht geladen werden',
    downloadCertificateError: 'Zertifikat konnte nicht heruntergeladen werden',
    shareCertificateError: 'Zertifikat konnte nicht geteilt werden',
  },
  
  pt: {
    // Section Tabs
    myCertificates: 'Meus Certificados',
    communityShowcase: 'Vitrine da Comunidade',
    
    // Certificate Types
    quizCompletion: 'Conclusão de Quiz',
    streakAchievement: 'Conquista de Sequência',
    referralMilestone: 'Marco de Indicação',
    eventParticipation: 'Participação em Evento',
    leadershipRecognition: 'Reconhecimento de Liderança',
    
    // Certificate Details
    issued: 'Emitido',
    public: 'Público',
    downloads: 'downloads',
    download: 'Baixar',
    share: 'Compartilhar',
    
    // Empty State
    noCertificatesYet: 'Ainda Sem Certificados',
    noPublicCertificates: 'Sem Certificados Públicos',
    earnCertificatesMessage: 'Complete questionários e alcance marcos para ganhar certificados!',
    checkBackLater: 'Volte mais tarde para conquistas inspiradoras da comunidade.',
    
    // Achievement Tips
    howToEarnTitle: '💡 Como Ganhar Certificados:',
    tipCompleteQuizzes: '• Complete questionários bíblicos com pontuações altas',
    tipMaintainStreaks: '• Mantenha sequências diárias de questionários',
    tipReferFriends: '• Indique amigos para se juntarem ao Kingdom Bible Quiz',
    tipParticipateEvents: '• Participe de eventos ao vivo',
    tipShowLeadership: '• Mostre liderança em sua comunidade',
    
    // Error Messages
    error: 'Erro',
    loadCertificatesError: 'Falha ao carregar certificados',
    downloadCertificateError: 'Falha ao baixar certificado',
    shareCertificateError: 'Falha ao compartilhar certificado',
  },
  
  ru: {
    // Section Tabs
    myCertificates: 'Мои Сертификаты',
    communityShowcase: 'Витрина Сообщества',
    
    // Certificate Types
    quizCompletion: 'Завершение Викторины',
    streakAchievement: 'Достижение Серии',
    referralMilestone: 'Веха Рефералов',
    eventParticipation: 'Участие в Событии',
    leadershipRecognition: 'Признание Лидерства',
    
    // Certificate Details
    issued: 'Выдан',
    public: 'Публичный',
    downloads: 'скачиваний',
    download: 'Скачать',
    share: 'Поделиться',
    
    // Empty State
    noCertificatesYet: 'Пока Нет Сертификатов',
    noPublicCertificates: 'Нет Публичных Сертификатов',
    earnCertificatesMessage: 'Проходите викторины и достигайте вех, чтобы заработать сертификаты!',
    checkBackLater: 'Вернитесь позже за вдохновляющими достижениями сообщества.',
    
    // Achievement Tips
    howToEarnTitle: '💡 Как Заработать Сертификаты:',
    tipCompleteQuizzes: '• Проходите библейские викторины с высокими баллами',
    tipMaintainStreaks: '• Поддерживайте ежедневные серии викторин',
    tipReferFriends: '• Приглашайте друзей присоединиться к Kingdom Bible Quiz',
    tipParticipateEvents: '• Участвуйте в живых событиях',
    tipShowLeadership: '• Проявляйте лидерство в своем сообществе',
    
    // Error Messages
    error: 'Ошибка',
    loadCertificatesError: 'Не удалось загрузить сертификаты',
    downloadCertificateError: 'Не удалось скачать сертификат',
    shareCertificateError: 'Не удалось поделиться сертификатом',
  },
  
  tl: {
    // Section Tabs
    myCertificates: 'Mga Certificate Ko',
    communityShowcase: 'Community Showcase',
    
    // Certificate Types
    quizCompletion: 'Pagkakatapos ng Quiz',
    streakAchievement: 'Nakamit na Streak',
    referralMilestone: 'Referral Milestone',
    eventParticipation: 'Pakikilahok sa Event',
    leadershipRecognition: 'Pagkilala sa Leadership',
    
    // Certificate Details
    issued: 'Na-issue',
    public: 'Public',
    downloads: 'mga download',
    download: 'I-download',
    share: 'I-share',
    
    // Empty State
    noCertificatesYet: 'Wala Pang mga Certificate',
    noPublicCertificates: 'Walang Public na mga Certificate',
    earnCertificatesMessage: 'Kumpletuhin ang mga quiz at makamit ang mga milestone para makakuha ng mga certificate!',
    checkBackLater: 'Bumalik mamaya para sa mga nakaka-inspire na achievement mula sa community.',
    
    // Achievement Tips
    howToEarnTitle: '💡 Paano Makakuha ng mga Certificate:',
    tipCompleteQuizzes: '• Kumpletuhin ang mga Bible quiz na may mataas na score',
    tipMaintainStreaks: '• Panatilihin ang araw-araw na quiz streaks',
    tipReferFriends: '• I-refer ang mga kaibigan para sumali sa Kingdom Bible Quiz',
    tipParticipateEvents: '• Makiisa sa mga live events',
    tipShowLeadership: '• Magpakita ng leadership sa inyong community',
    
    // Error Messages
    error: 'Error',
    loadCertificatesError: 'Hindi na-load ang mga certificate',
    downloadCertificateError: 'Hindi na-download ang certificate',
    shareCertificateError: 'Hindi na-share ang certificate',
  },
  
  it: {
    // Section Tabs
    myCertificates: 'I Miei Certificati',
    communityShowcase: 'Vetrina della Comunità',
    
    // Certificate Types
    quizCompletion: 'Completamento Quiz',
    streakAchievement: 'Risultato Streak',
    referralMilestone: 'Traguardo Referral',
    eventParticipation: 'Partecipazione Evento',
    leadershipRecognition: 'Riconoscimento Leadership',
    
    // Certificate Details
    issued: 'Rilasciato',
    public: 'Pubblico',
    downloads: 'download',
    download: 'Scarica',
    share: 'Condividi',
    
    // Empty State
    noCertificatesYet: 'Nessun Certificato Ancora',
    noPublicCertificates: 'Nessun Certificato Pubblico',
    earnCertificatesMessage: 'Completa i quiz e raggiungi traguardi per guadagnare certificati!',
    checkBackLater: 'Torna più tardi per i risultati ispiranti dalla comunità.',
    
    // Achievement Tips
    howToEarnTitle: '💡 Come Guadagnare Certificati:',
    tipCompleteQuizzes: '• Completa i quiz biblici con punteggi alti',
    tipMaintainStreaks: '• Mantieni streak quotidiane di quiz',
    tipReferFriends: '• Invita amici a unirsi a Kingdom Bible Quiz',
    tipParticipateEvents: '• Partecipa agli eventi dal vivo',
    tipShowLeadership: '• Mostra leadership nella tua comunità',
    
    // Error Messages
    error: 'Errore',
    loadCertificatesError: 'Impossibile caricare i certificati',
    downloadCertificateError: 'Impossibile scaricare il certificato',
    shareCertificateError: 'Impossibile condividere il certificato',
  },
  
  am: {
    // Section Tabs
    myCertificates: 'የኔ ምስክርወረቀቶች',
    communityShowcase: 'የማህበረሰብ ማሳያ',
    
    // Certificate Types
    quizCompletion: 'የጥያቄ ጥቅል ማጠናቀቅ',
    streakAchievement: 'የተከታታይ ስኬት',
    referralMilestone: 'የሪፈራል ክንውን',
    eventParticipation: 'በክስተት ውስጥ መሳተፍ',
    leadershipRecognition: 'የአመራር እውቅና',
    
    // Certificate Details
    issued: 'ተሰጥቷል',
    public: 'ሕዝባዊ',
    downloads: 'ማውረጃዎች',
    download: 'አውርድ',
    share: 'አጋራ',
    
    // Empty State
    noCertificatesYet: 'እስካሁን ምስክርወረቀቶች የሉም',
    noPublicCertificates: 'ሕዝባዊ ምስክርወረቀቶች የሉም',
    earnCertificatesMessage: 'ጥያቄዎችን ይጨርሱ እና ክንውኖችን ይድረሱ ምስክርወረቀቶችን ለማግኘት!',
    checkBackLater: 'ከማህበረሰቡ አበረታች ስኬቶች ለማየት በኋላ ይመለሱ።',
    
    // Achievement Tips
    howToEarnTitle: '💡 ምስክርወረቀቶችን እንዴት ማግኘት ይቻላል:',
    tipCompleteQuizzes: '• የመጽሐፍ ቅዱስ ጥያቄዎችን ከፍተኛ ውጤት በማግኘት ይጨርሱ',
    tipMaintainStreaks: '• የዕለት ተዕለት ጥያቄ ተከታታይነት ይያዙ',
    tipReferFriends: '• ወዳጆችን Kingdom Bible Quiz እንዲቀላቀሉ ይመክሩ',
    tipParticipateEvents: '• በቀጥታ ክስተቶች ውስጥ ይሳተፉ',
    tipShowLeadership: '• በእርስዎ ማህበረሰብ ውስጥ አመራር ያሳዩ',
    
    // Error Messages
    error: 'ስህተት',
    loadCertificatesError: 'ምስክርወረቀቶችን መጫን አልተሳካም',
    downloadCertificateError: 'ምስክርወረቀት ማውረድ አልተሳካም',
    shareCertificateError: 'ምስክርወረቀት ማጋራት አልተሳካም',
  },
  
  ko: {
    // Section Tabs
    myCertificates: '내 인증서',
    communityShowcase: '커뮤니티 쇼케이스',
    
    // Certificate Types
    quizCompletion: '퀴즈 완료',
    streakAchievement: '연속 달성',
    referralMilestone: '추천 마일스톤',
    eventParticipation: '이벤트 참여',
    leadershipRecognition: '리더십 인정',
    
    // Certificate Details
    issued: '발급됨',
    public: '공개',
    downloads: '다운로드',
    download: '다운로드',
    share: '공유',
    
    // Empty State
    noCertificatesYet: '아직 인증서가 없음',
    noPublicCertificates: '공개 인증서 없음',
    earnCertificatesMessage: '퀴즈를 완료하고 마일스톤을 달성하여 인증서를 획득하세요!',
    checkBackLater: '커뮤니티의 영감을 주는 성취를 보려면 나중에 다시 확인하세요.',
    
    // Achievement Tips
    howToEarnTitle: '💡 인증서를 얻는 방법:',
    tipCompleteQuizzes: '• 높은 점수로 성경 퀴즈 완료',
    tipMaintainStreaks: '• 일일 퀴즈 연속 기록 유지',
    tipReferFriends: '• 친구들을 Kingdom Bible Quiz에 추천',
    tipParticipateEvents: '• 라이브 이벤트 참여',
    tipShowLeadership: '• 커뮤니티에서 리더십 발휘',
    
    // Error Messages
    error: '오류',
    loadCertificatesError: '인증서 로드 실패',
    downloadCertificateError: '인증서 다운로드 실패',
    shareCertificateError: '인증서 공유 실패',
  },
};